<template>
  <div id="app">
    <website-header />
    <top-nav />
    <toast-messages />
    <indeed-tracker />
    <div v-if="isSignedIn || isPublicRoute">
      <router-view v-if="canSeeRoute" />
      <no-access v-else />
    </div>
    <div v-else>
      <router-view v-if="isLoginPinRoute" />
      <login-signup v-else />
    </div>
    <page-footer />
  </div>
</template>

<script>
import {
  EventBus,
  ToastMessages,
} from '@switchsystems/coactive-vue-lib';
import { mapGetters } from 'vuex';
/* eslint-disable-next-line import/no-extraneous-dependencies */
import { onAuthUIStateChange, AuthState } from '@aws-amplify/ui-components';
import WebsiteHeader from '@/components/WebsiteHeader.vue';
import TopNav from '@/components/TopNav.vue';
import NoAccess from '@/components/NoAccess.vue';
import PageFooter from '@/components/PageFooter.vue';
import LoginSignup from '@/components/LoginSignup.vue';
import IndeedTracker from '@/components/IndeedTracker.vue';
import '@/assets/scss/app.scss';

export default {
  name: 'App',
  components: {
    WebsiteHeader,
    TopNav,
    ToastMessages,
    LoginSignup,
    NoAccess,
    PageFooter,
    IndeedTracker,
  },
  mounted() {
    EventBus.$on('auth:logout', () => {
      this.$store.dispatch('auth/logoutUser');
    });
  },
  created() {
    onAuthUIStateChange((authState, authData) => {
      this.$store.dispatch('auth/onAuthUIStateChange', authState, authData);
      if (authState === AuthState.SignedIn) {
        if (this.applyForJob.length > 0) {
          this.$router.push({
            name: 'job/apply',
            params: {
              ref: this.applyForJob,
            },
          });
        }
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('auth:logout');
    return onAuthUIStateChange;
  },
  metaInfo() {
    return {
      title: this.$route.meta.title,
      titleTemplate: (title) => (title ? `${title} | Recruitment | CoactiveCare` : 'Recruitment | CoactiveCare'),
    };
  },
  computed: {
    ...mapGetters({
      isSignedIn: 'auth/isSignedIn',
      applyForJob: 'userstate/applyForJob',
    }),
    isPublicRoute() {
      return this.$route.meta.public === true;
    },
    canSeeRoute() {
      return this.isSignedIn || this.isPublicRoute;
    },
    isLoginPinRoute() {
      return this.$route.name === 'sign-in-pin';
    },
  },
};
</script>
